import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Terms & Conditions – Wedding Stays
      </h1>

      {/* Introduction */}
      <section className="mb-8">
        <p className="text-lg">
          These Terms and Conditions govern your use of the Wedding Stays
          website and services. By accessing or using our website, you agree to
          comply with these terms. If you do not agree, please do not use our
          services.
        </p>
      </section>

      {/* Services */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">1. Our Services</h2>
        <p className="text-lg">
          Wedding Stays provides structured guest accommodation management
          services for weddings and related events. Our services may include:
        </p>
        <ul className="list-disc list-inside ml-4 mt-2 space-y-1 text-lg">
          <li>Hotel and resort coordination</li>
          <li>Guest room allocation planning</li>
          <li>Hospitality desk management</li>
          <li>Transport coordination support</li>
          <li>Vendor stay assistance</li>
        </ul>
        <p className="text-lg mt-2">
          We act as facilitators between families and hospitality partners.
        </p>
      </section>

      {/* Booking & Payments */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">2. Booking & Payments</h2>
        <ul className="list-disc list-inside ml-4 space-y-1 text-lg">
          <li>
            All bookings are subject to availability and confirmation from
            partner hotels or resorts.
          </li>
          <li>
            Payment terms will be communicated clearly before confirmation.
          </li>
          <li>
            Cancellation and refund policies may vary depending on the hotel or
            service provider.
          </li>
        </ul>
      </section>

      {/* User Responsibilities */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">3. User Responsibilities</h2>
        <p className="text-lg">By using our services, you agree that:</p>
        <ul className="list-disc list-inside ml-4 mt-2 space-y-1 text-lg">
          <li>
            The information you provide (guest details, event dates, etc.) is
            accurate and complete.
          </li>
          <li>
            You will not misuse our platform for fraudulent or unlawful
            activities.
          </li>
          <li>
            You understand that final hospitality services are delivered by
            third-party hotels or vendors.
          </li>
        </ul>
      </section>

      {/* Limitation of Liability */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">
          4. Limitation of Liability
        </h2>
        <p className="text-lg">
          Wedding Stays acts as a coordination platform. While we strive to
          ensure seamless guest experiences, we are not liable for:
        </p>
        <ul className="list-disc list-inside ml-4 mt-2 space-y-1 text-lg">
          <li>Hotel operational delays</li>
          <li>Vendor service failures</li>
          <li>Force majeure events</li>
          <li>Unforeseen logistical disruptions</li>
        </ul>
      </section>

      {/* Intellectual Property */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">5. Intellectual Property</h2>
        <p className="text-lg">
          All content on this website, including text, branding, graphics, and
          images, is the property of Wedding Stays and may not be copied,
          reproduced, or distributed without permission.
        </p>
      </section>

      {/* Third Party Links */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">6. Third-Party Links</h2>
        <p className="text-lg">
          Our website may contain links to third-party websites. We are not
          responsible for the content, privacy practices, or policies of such
          external platforms.
        </p>
      </section>

      {/* Modifications */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">7. Changes to Terms</h2>
        <p className="text-lg">
          Wedding Stays reserves the right to modify these Terms and Conditions
          at any time. Continued use of our website after changes are posted
          constitutes acceptance of the updated terms.
        </p>
      </section>

      {/* Governing Law */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">8. Governing Law</h2>
        <p className="text-lg">
          These Terms shall be governed by and interpreted in accordance with
          the laws of India. Any disputes shall be subject to the jurisdiction
          of the appropriate courts in India.
        </p>
      </section>

      {/* Last Updated */}
      <div className="mt-10 text-center text-gray-500">
        <p>Last Updated: February 2026</p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
